import {
  Text,
  Box,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Input,
  InputGroup,
  InputLeftAddon,
  Textarea,
} from '@chakra-ui/react';
import { IconAlertCircle } from '../../../../../styles/icons';
import {useState, useEffect, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import {updateProfileValue} from "../../../../redux/actions/user";

const EditSectionFees = ({ profile }) => {
  const [averagePrice, setAveragePrice] = useState(profile.averagePrice?.toFixed(2) ?? null);
  const [feeStructure, setFeeStructure] = useState(profile.feeStructure || '');

  // initialise fees
  useEffect(() => {
    setAveragePrice(profile.averagePrice);
    setFeeStructure(profile.feeStructure);
  }, [profile]);

  const dispatch = useDispatch();

  const handleProfileValueUpdate = useCallback((key, value) => {
    if(key === 'averagePrice') {
      if(value === '') {
        dispatch(updateProfileValue(key, 0))
      }
      else {
        const price = Number(value);
        dispatch(updateProfileValue(key, price))
      }
      return;
    }
    dispatch(updateProfileValue(key, value))
  }, [dispatch]);

  // Render
  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            textAlign="left"
          >
            <Box>
              <Text>Fee structure</Text>
              <Text textStyle="footer2" color="brand.200">
                Average Fee: £{profile.averagePrice?.toFixed(2)}
              </Text>
              <Text
                textStyle="footer2"
                color="brand.200"
                noOfLines={1}
                maxWidth="300px"
              >
                {profile.feeStructure}
              </Text>
            </Box>
            {profile.averagePrice > 0 ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Add your average fee per session
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className='w-full'>
            <h3 className="text-lg text-slate-600 font-bold pb-2 flex items-center">
              Please add your average fee for a single session
              <p className="text-red-500 superscript text-sm pl-1">*</p>
            </h3>
            <InputGroup>
              <InputLeftAddon>£</InputLeftAddon>
              <Input
                type="number"
                placeholder="Average fee"
                value={averagePrice > 0 ? averagePrice : null}
                onChange={(e) => {
                  handleProfileValueUpdate('averagePrice', Number(e.target.value).toFixed(2))
                  setAveragePrice(e.target.value)
                }}
              />
            </InputGroup>
          </div>
          <div className='w-full'>
            <h3 className="text-lg text-slate-600 font-bold pb-2">
              Fee structure
            </h3>
            <Textarea
              size="sm"
              bg="brand.100"
              width="100%"
              name="feeStructure"
              value={feeStructure}
              onChange={(e) => {
                handleProfileValueUpdate('feeStructure', e.target.value)
                setFeeStructure(e.target.value)
              }}
              placeholder=" Add any other information related to your fees here."
            />
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionFees;
